import {enableProdMode} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';
import 'zone.js';
import '@angular/localize/init';

import {environment} from '../environments/environment';
import {AppModule} from './modulo-geoanalise/app.module';

if (environment.production) {
    enableProdMode();
}

platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.log(err));
